<!--
 * @Author: your name
 * @Date: 2021-03-10 10:41:44
 * @LastEditTime: 2021-03-10 10:43:55
 * @LastEditors: Please set LastEditors
 * @Description: 运单仓库预约
 * @FilePath: \e6-module-park-management\src\e6-module-park-management\views\businessManagement\waybillStoreBooking\waybillBooking.vue
-->
<template>
  <booking-edit pageType="waybill"></booking-edit>
</template>

<script>
import bookingEdit from "../components/bookingEdit";
export default {
  name: "waybillStoreBooking",
  components: {
    bookingEdit
  }
};
</script>
